export type RecommendationInvalidFieldTabKey = 'assessors' | 'auditors' | 'basic' | 'files' | 'logs' | 'hidden';

export const RECOMMENDATION_INVALID_FIELD_TAB_BY_FIELD: Record<string, RecommendationInvalidFieldTabKey> = {
  // Auditee's Processing
  recommendationId: 'assessors',
  currentDeadlineDate: 'assessors',

  // Auditor's Processing
  title: 'auditors',
  sequenceNumber1: 'auditors',
  sequenceNumber2: 'auditors',
  priority: 'auditors',
  isLegallyRequired: 'auditors',
  budget: 'auditors',
  category: 'auditors',
  initialDeadline: 'auditors',
  prolongationDeadline: 'auditors',
  status: 'auditors',
  adjournedReason: 'auditors',
  settledRejectReason: 'auditors',

  // Basic definitions
  auditId: 'basic',
  auditDefinition: 'basic',
  recommendationTitle: 'basic',
  isSpecialAudit: 'basic',
  plant: 'basic',
  concernsName: 'basic',
  concernsCountry: 'basic',
  reportingYear: 'basic',
  legalUnit: 'basic',
  department: 'basic',
  auditor: 'basic',
  assessmentCoordinator: 'basic',
  assessmentCoordinatorName: 'basic',
  legalUnitResponsibles: 'basic',
  legalUnitResponsiblesNames: 'basic',
  emailAddress: 'basic',

  // Files
  fileLinkId: 'files',

  // Logs
  modificationAction: 'logs',
  modificationDate: 'logs',
  modificationStatus: 'logs',

  // Hidden fields
  shortText1: 'hidden',
  shortText2: 'hidden'
};
